<template>
  <aslider
    animation="fade"
    :autoplay="auto"
    :interval="4000"
    :indicators="slideCount > 1"
    :control-btn="slideCount > 1"
    :class="[
      isGallery ? 'slider-gallery' : '',
      isCoverImages ? 'cover-images' : '',
      isCentered ? 'centered' : '',
      isRightAligned ? 'flow-right' : ''
    ]"
  >
    <preloader key="preloader" v-if="!pageReady" class="" />
    <template v-else>
      <slider-item
        v-for="(item, index) in children"
        :key="index"
        :style="sliderItemStyle(item)"
        :class="[
          isDark ? 'dark' : '',
          'px-2xl',
          isCoverImages ? 'is-cover' : ''
        ]"
      >
        <div
          v-if="!isGallery"
          :class="['slider-item--heading', isCoverImages ? 'lonely' : '']"
        >
          <!-- 'rellax', -->

          <!-- <slot></slot> -->
          
          <!--
        <svg style="width:150px;height:auto;clear:both;" data-v-4ef0a45b="" fill="#ffffff" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 193.1 84.1" xml:space="preserve" class="mis-logo"><path data-v-4ef0a45b="" id="MIS" d="M175.6,83.7h-61v-6.5h60.9c5.8-0.1,10.5-4.8,10.4-10.6c-0.1-4.8-3.4-9-8.1-10.1c-1.5-0.4-3-0.7-4.9-1
          c0,0-4.5-0.5-16.7-2c-10-1.1-15.1-1.6-27.8-3.3c-1.7-0.2-3.4-0.6-5-1c-2.4-0.6-4.5-1.7-6.4-3.2c-2-1.8-3-4.4-2.6-7
          c-0.2-5.7,4.2-10.5,9.9-10.8h22.7v6.5h-21.4c-2.4,0-4.3,1.9-4.3,4.3c0,0,0,0,0,0l0,0c-0.1,1.7,1,3.3,2.6,3.8c1.6,0.6,7.8,1.3,10,1.7
          c1.7,0.3,22.2,2.7,22.2,2.7s20.1,2.6,21.6,2.8c9.3,0.9,16.1,9.2,15.2,18.4c-0.8,8.6-8,15.2-16.6,15.3L175.6,83.7L175.6,83.7z
          M175.6,83.7h-61v-6.5h60.9c5.8-0.1,10.5-4.8,10.4-10.6c-0.1-4.8-3.4-9-8.1-10.1c-1.5-0.4-3-0.7-4.9-1c0,0-4.5-0.5-16.7-2
          c-10-1.1-15.1-1.6-27.8-3.3c-1.7-0.2-3.4-0.6-5-1c-2.4-0.6-4.5-1.7-6.4-3.2c-2-1.8-3-4.4-2.6-7c-0.2-5.7,4.2-10.5,9.9-10.8h22.7v6.5
          h-21.4c-2.4,0-4.3,1.9-4.3,4.3c0,0,0,0,0,0l0,0c-0.1,1.7,1,3.3,2.6,3.8c1.6,0.6,7.8,1.3,10,1.7c1.7,0.3,22.2,2.7,22.2,2.7
          s20.1,2.6,21.6,2.8c9.3,0.9,16.1,9.2,15.2,18.4c-0.8,8.6-8,15.2-16.6,15.3L175.6,83.7L175.6,83.7z M104.1,0v21.3H98V0H104.1z
          M98,28.3h6.2v55.8H98V28.3z M104.1,0v21.3H98V0H104.1z M98,28.3h6.2v55.8H98V28.3z M47.8,84.1h-6.2V38c0.1-1.3-0.4-2.7-1.4-3.5
          c-0.7-0.5-1.6-0.7-2.4-0.7c-1.2,0-2,0-3.9,3L7.5,84.1H0l6.3-11.6c2.4-3,19.9-35.7,19.9-35.7C29.5,31.3,32,28,36,28
          c1.2-0.1,2.3-0.1,3.5,0c1.7,0.2,3.2,0.8,4.5,1.9c1.1,0.9,2,1.9,2.6,3.2c0.8,1.4,1.2,3,1.2,4.6V71c4.7-7.6,18.9-34,18.9-34
          c3.2-5.6,5.7-8.9,9.7-8.9c1.2-0.1,2.3-0.1,3.5,0c1.6,0.2,3.1,0.8,4.3,1.8c1.1,0.9,2,1.9,2.6,3.2c0.8,1.4,1.2,3,1.2,4.6v46.4h-6.1V38
          c0.3-1.9-1-3.7-2.9-4c0,0,0,0,0,0h-0.2h-0.8c-1.2,0-2,0-3.9,3L47.8,84.1z" class="logo-path"></path></svg>
          <br/>
          -->

          <h1
            v-if="item.title && compIndex === 0"
            :class="['mb-xs', isSmallerFont ? 'heading__2' : '']"
            v-html="parseTitle(item.title)"
          ></h1>
          <h2 v-else class="font-rg mb-xs" v-html="parseTitle(item.title)"></h2>
          <h4 v-if="!subnote && item.sub_title" v-text="item.sub_title"></h4>
          <div
            v-if="item.children && item.children.length"
            class="btn-group pt-xl"
          >
            <abtn
              :class="['mr-l', 'text-white']"
              v-for="button in item.children"
              :key="button.title"
              v-bind="button"
              mini
            >
              <span v-text="button.title"></span>
            </abtn>
          </div>
        </div>
        <img
          v-if="item.image && !isCoverImages"
          :src="parseImage(item)"
          :alt="item.title"
          :title="item.title"
        />
        <div
          v-if="isGallery && (item.title || item.sub_title)"
          class="slider--text pb-xl"
        >
          <h5
            v-if="item.title"
            class="mb-xs text--m font-rg"
            v-html="item.title"
          ></h5>
          <h6
            v-if="item.sub_title"
            class="text--s lh-1"
            v-text="item.sub_title"
          ></h6>
        </div>
      </slider-item>
    </template>
  </aslider>
  <!--:style="i"-->
</template>
<script>
// import Rellax from "rellax";
import { mapState } from "vuex";
import { Slider, SliderItem } from "vue-easy-slider";
export default {
  props: {
    /*
      This will make the subtitle appear in the bottom of the
      slide as a small note.
    */
    subnote: {
      type: Boolean,
      default: false
    },
    title: String,
    children: {
      type: Array,
      required: false
    },
    isGallery: {
      type: Boolean,
      default: false
    },
    compIndex: {
      type: Number,
      default: -1
    },
    properties: {
      type: Object,
      default() {
        return {};
      }
    },
    auto: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      rellax: null
    };
  },
  components: {
    aslider: Slider,
    SliderItem
  },
  mounted() {
    // console.log("1 SLIDER CREATED!!", document.querySelectorAll(".rellax"));
    // this.rellax = new Rellax(".rellax", {
    //   speed: -4,
    //   center: false,
    //   wrapper: null,
    //   round: true,
    //   vertical: true,
    //   horizontal: false
    // });
    // console.log("2 SLIDER CREATED!!", this.rellax);
  },
  methods: {
    parseTitle(title) {
      if (!title) {
        return "";
      }
      if (title.indexOf("@") > -1) {
        // RETURN SVG
        let svg = title.substring(1);
        return `<img src="/img/product-logos/${svg}.svg" alt="${svg}" title="${svg}" />`;
      }
      return title;
    },
    sliderItemStyle(item) {
      let stylestring = "",
        _image =
          this.dimensions.width < 600 && item.mobile_image
            ? item.mobile_image
            : item.image;
      stylestring += item.color ? "background-color:" + item.color + ";" : "";
      stylestring += this.isCoverImages
        ? `; background-image:url(${this.$imageFolder + "/" + _image})`
        : "";
      return stylestring;
      // 'background-color:red'
      // this.isCoverImages ? `; background-image:url(${this.$imageFolder + '/' + item.image})` : ''
    },
    parseImage(item) {
      return (
        this.$imageFolder +
        "/" +
        (this.dimensions.width < 600 && item.mobile_image
          ? item.mobile_image
          : item.image)
      );
    }
  },
  computed: {
    ...mapState(["pageReady", "dimensions"]),
    slideCount() {
      return this.children.length;
    },
    isCoverImages() {
      return this.properties && this.properties.isCoverImages;
    },
    isCentered() {
      return this.properties && this.properties.isCentered;
    },
    isRightAligned() {
      return this.properties && this.properties.isRightAligned;
    },
    isSmallerFont() {
      return this.properties && this.properties.smallerFont;
    },
    isDark() {
      return this.properties && this.properties.isDarkCover;
    }
  }
};
</script>
<style lang="stylus">
.slider
  // z-index 101
  height auto !important
  // height 56vh !important
  // /.home &
  +below(815px)
    height 300px !important
  &:not(.slider-gallery)
    // min-height 420px
    +below(815px)
      min-height initial
    &.cover-images
      height 60vh !important
      min-height 300px
      /.home &
        height 70vh !important
      +below(1024px)
        height 50vh !important
      +below(920px)
        height 40vh !important
  // +portrait()
  //   height 32vh !important
  /.catalog &
    height 40vh !important
    min-height 400px
  /.overlay-gallery &
    height 100% !important
  /.home &
    height 70vh !important
    // +below(415px)
    //   height 100% !important
  &.centered *
    text-align center
.slider-item
  _flex(column, nowrap, flex-end, space-between)
  position relative !important
  background-repeat no-repeat
  background-size cover
  background-position center
  background-position 50% 50%
  background-color blue_primary

  +below(600px, orientation: portrait)
    &.is-cover
      _flex(column, nowrap, center, center)
    &:not(.is-cover)
      _flex(column, nowrap, center, flex-end)
  /.flow-right &
    justify-content flex-end
  &.dark
    &:before
      content ''
      background rgba(gray_9, 0.2) url(/img/dark-net.png) repeat 0 0
      background-attachment fixed
      position absolute 0 0 0 0
      z-index 5
      backface-visibility hidden
      transform translateZ(0)
      opacity 0.3
  +above(26em)
    _flex(row, nowrap, center, space-between)
    // padding 0 8vw
  &--heading
    position relative
    z-index 6
    color #fff
    fill #fff
    flex 1
    max-width 52%
    /.flow-right &
      flex 0 0 50%
    +below(815px)
      +landscape()
        padding-left 3vw
      h1
        font-size 24px
        display flex !important
      h4
        font-size 17px
    +below(600px)
      width 85%
      &:not(.lonely)
        flex none
        position absolute
        top 10%
        max-width 85%
        text-align center
      &.lonely
        position absolute
        top 10%
        left 50%
        transform translateX(-50%)
        flex none
        max-width initial
        text-align center
      & *
        text-align center
        margin-left auto
        margin-right auto
        align-items center
        justify-content center
    +desktop()
      &:not(.lonely)
        max-width 50%
    h1, h2
      display inline-flex
      img
        height 46px
        max-width 100%
        +above(26em)
          height 60px
        +above(52em)
          height 90px
      /.centered &
        display block

  & > img
    // position relative
    height 100%
    max-height 28vw
    +portrait()
      height auto
      max-width 50%
      +below(600px)
        max-width 100%
        max-height 80%
.slider-indicators
  transform translateX(-50%)
  left 50%
  .slider-indicator-icon
    margin 0 .3rem !important
.slider-indicator-active
  background rgba(gray_9, 0.8) !important
.slider-gallery
  .slider-item
    // min-height 54vh
    background none
    _flex(row,wrap, center,center)
    img
      max-height 95%
      max-width 95%
      height auto
      +below(600px)
        margin-bottom 15px //dubix
      // center()
  .slider-btn
    background none !important
    .slider-indicators
      bottom 0 !important
    .slider-icon
      transform-origin 50%
      border-color gray_6 !important
    +below(600px, orientation:landscape)
      width 30px !important
      padding 0
      .slider-icon
        position absolute
        top 50%
        left 50%
        &.slider-icon-right
          transform translate(-50%,-50%) rotate(-135deg)
        &.slider-icon-left
          transform translate(-50%,-50%) rotate(45deg)
</style>
